import appClient from "./appClient";

export const authUserByInitData = async (initData) => {
    try {
        if (!initData) { throw new Error("Missing initData"); }

        const response = await appClient.post("/auth/customer", { initData });
        return response.data;
    } catch (error) {
        console.error("Error authenticating user:", error);
        throw new Error("Failed to authenticate user.");
    }
}

export const handleLogin = async (login, password) => {
    if (!login || !password) {
        throw new Error("Missing login or password");
    }
    try {
        const response = await appClient.post("/auth/handle", { login, password });
        let res = true
        if (!response.data.token) {
            res = false
        }
        return { res, token: response.data?.token };
    } catch (error) {
        console.error("Error logging in:", error);
        throw new Error("Failed to log in.");
    }
}